import { mapGetters } from 'vuex'
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ],
  computed: {
    ...mapGetters(['_users'])
  },
  methods: {
    _userDetails (uid) {
      return (this._users[uid] || {}).details || {}
    },
    _userName (uid) {
      return `${this._userDetails(uid).firstName || ''} ${this._userDetails(uid).lastName || ''}`
    },
    _userInitials (uid) {
      return this._initials(this._userName(uid))
    },
    _userProfileImage (uid) {
      return (this._userDetails(uid).image || {}).src || null
    },
    _userProfileColor (uid) {
      return this._userDetails(uid).color || 'blue-grey lighten-1'
    }
  }
}
